import { render, staticRenderFns } from "./RsSurveySubmit.vue?vue&type=template&id=f457afe4&scoped=true"
import script from "./RsSurveySubmit.vue?vue&type=script&lang=js"
export * from "./RsSurveySubmit.vue?vue&type=script&lang=js"
import style0 from "./RsSurveySubmit.vue?vue&type=style&index=0&id=f457afe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f457afe4",
  null
  
)

export default component.exports